<template>
  <v-app style="background: #757575">
    <span v-if="layout">
      <v-main>
        <router-view />
      </v-main>
    </span>
    <span v-else>
      <nav-bar />
      <v-main>
        <v-container fluid fill-height>
          <v-row>
            <v-col cols="12"><router-view /></v-col>
          </v-row>
        </v-container>
      </v-main>
    </span>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
  computed: {
    layout() {
      return this.$route.meta.layout === "full" ? true : false;
    },
  },
};
</script>

<style lang="scss">
@import "./scss/variables.scss";



v-app {
  font-family: $body-font-family !important;
}

</style>